var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V16M16 20V20.0133",
    stroke: "#F1B007",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66651 25.3332H25.3332C25.7683 25.3301 26.196 25.2207 26.579 25.0144C26.9621 24.808 27.2888 24.5111 27.5308 24.1495C27.7727 23.7879 27.9225 23.3726 27.9671 22.9398C28.0117 22.507 27.9497 22.0699 27.7865 21.6665L18.3198 5.33319C18.0892 4.91639 17.7512 4.56897 17.3408 4.32704C16.9305 4.08511 16.4629 3.95752 15.9865 3.95752C15.5102 3.95752 15.0425 4.08511 14.6322 4.32704C14.2218 4.56897 13.8838 4.91639 13.6532 5.33319L4.18651 21.6665C4.02644 22.0606 3.96296 22.4873 4.00138 22.9109C4.0398 23.3346 4.17901 23.7429 4.40738 24.1017C4.63575 24.4606 4.94666 24.7596 5.31415 24.9739C5.68164 25.1881 6.09504 25.3113 6.51985 25.3332",
    stroke: "#F1B007",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaution);
export default __webpack_public_path__ + "static/media/icon_caution.292ad45b4c8ffc556d153d8ec58a0740.svg";
export { ForwardRef as ReactComponent };